import { useEffect, useState } from 'react';

import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';

const TemplateBrowserPreview = ({ template, compact = false, className = '' }) => {
	const [loading, setLoading] = useState(true);
	const [reloadKey, setReloadKey] = useState(0);
	const deploy = template.deploy || {};
	const url = deploy.url || '';

	useEffect(() => setLoading(Boolean(url)), [url, reloadKey]);

	return (
		<section className={cn('overflow-hidden rounded-panel border border-border bg-surface', className)}>
			<div className='flex h-9 items-center justify-between gap-2 border-b px-3 text-xs text-foreground-subtle'>
				<span className='w-12' />
				<span className='max-w-md truncate rounded-control border bg-canvas px-3 py-1'>
					{url || 'Preview unavailable'}
				</span>
				<div className='flex w-12 justify-end gap-1'>
					<Button
						variant='ghost'
						size='icon-xs'
						aria-label='Reload preview'
						disabled={!url}
						onClick={() => setReloadKey(value => value + 1)}>
						<Icon icon='rotate-right' aria-hidden />
					</Button>
					<Link
						variant='ghost'
						size='icon-xs'
						prevIcon='arrow-up-right-from-square'
						aria-label='Open preview'
						href={url}
						target='_blank'
						disabled={!url}
					/>
				</div>
			</div>
			<div
				className={cn(
					'relative flex items-center justify-center bg-[#20242b]',
					compact ? 'h-[55vh]' : 'aspect-video min-h-72',
				)}>
				{url ? (
					<>
						{loading ? (
							<Icon type='fad' icon='desktop' className='absolute size-8 text-foreground-subtle' aria-hidden />
						) : null}
						<iframe
							key={reloadKey}
							src={url}
							title={`${template.name} preview`}
							className='size-full border-0 bg-white'
							onLoad={() => setLoading(false)}
						/>
					</>
				) : (
					<div className='flex flex-col items-center gap-2 text-foreground-subtle'>
						<Icon type='fad' icon='desktop' className='size-8' aria-hidden />
						<span>Preview unavailable</span>
					</div>
				)}
			</div>
		</section>
	);
};

export { TemplateBrowserPreview };
